import axios from 'axios';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/users/`;

interface SendAccountRecoveryEmailDto {
  username: string;
  name: string;
  email: string;
  phone?: string;
  organisation?: string;
  additional?: string;
  recaptchaResponse: string;
  redirectUri?: string;
}

export default {
  async sendAccountRecoveryEmail(dto: SendAccountRecoveryEmailDto): Promise<any> {
    return axios.post(`${API_URL}${dto.username}/notify-us/account-recovery`, {
      name: dto.name,
      email: dto.email,
      phone: dto.phone,
      organisation: dto.organisation,
      additional: dto.additional,
      recaptchaResponse: dto.recaptchaResponse,
      redirectUri: dto.redirectUri,
    });
  },
};
